$(document).ready(function () {
  if ($(window).width() >= 1300) {
    // add show when hovered
    $(".nav-item.dropdown").hover(
      function () {
        console.log("hovered");
        // $(this).find("a.nav-link").addClass("show");
        $(this).find("a.dropdown-toggle").attr("aria-expanded", true);
        // $(this).find(".dropdown-menu").addClass("show");
        $(this).find(".dropdown-menu").attr("data-bs-popper", "static");
      },
      function () {
        console.log("unhovered");
        // $(this).find("a.nav-link").removeClass("show");
        $(this).find("a.dropdown-toggle").attr("aria-expanded", false);
        // $(this).find(".dropdown-menu").removeClass("show");
        $(this).find(".dropdown-menu").removeAttr("data-bs-popper");
      }
    );

    // Prevent the default behavior of the parent link when clicked

    $(".nav-item.dropdown > a.nav-link.dropdown-toggle").on(
      "click",
      function (e) {
        e.preventDefault();
        window.location.href = $(this).attr("href"); // Redirect to the parent link's URL
      }
    );

    // Toggle the 'show-from-top' class on the nav element
    $(".navbar-toggler").on("click", function () {
      $("#nav").toggleClass("show-from-top");
    });
  } else {
    $(document).ready(function () {
      // Add show class to the submenu when clicking on a.menu-item
      $(".dropdown-menu li.menu-item-has-children > a.dropdown-item").click(
        function (event) {
          // Prevent the event from propagating to the parent li.menu-item-has-children
          event.stopPropagation();

          // Check if the clicked submenu is already open
          const isOpen = $(this).siblings("ul.dropdown-menu").hasClass("show");

          // Close all open submenus
          $(
            ".dropdown-menu li.menu-item-has-children ul.dropdown-menu"
          ).removeClass("show");
          $(
            ".dropdown-menu li.menu-item-has-children a.dropdown-item"
          ).removeClass("show");
          $(".dropdown-menu li.menu-item-has-children").removeClass("open");

          // Toggle the 'show' class on the clicked submenu and its link
          if (!isOpen) {
            $(this).siblings("ul.dropdown-menu").toggleClass("show");
            $(this).parent("li").toggleClass("open");
            $(this).toggleClass("show");
          }
        }
      );

      // Prevent the default click behavior for menu items with children
      var menuItemsWithChildren = document.querySelectorAll(
        ".dropdown-menu li.menu-item-has-children > a"
      );

      menuItemsWithChildren.forEach(function (link) {
        link.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent the default click behavior
        });
      });

      // Add functionality to the mobile navigation toggle button
      $(".navbar-toggler").on("click", function () {
        $(".navbar").toggleClass("show");
      });
    });
  }

  window.addEventListener("load", function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    updateVhm();
  });

  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    updateVhm();
  });

  function updateVhm() {
    var vh = window.innerHeight;
    var navAlert = document.querySelector(".alert");
    var wpadminbar = document.querySelector("#wpadminbar");

    if (navAlert) {
      vh -= navAlert.offsetHeight;
    }

    if (wpadminbar) {
      vh -= wpadminbar.offsetHeight;
    }

    var vhm = vh * 0.01;
    document.documentElement.style.setProperty("--vhm", `${vhm}px`);
  }

  // adjust main for header size
  function adjustMarginTop() {
    var headerHeight = $("#header").outerHeight() + 12;
    $("#main").css("margin-top", headerHeight);
  }
  adjustMarginTop();
  $(window).resize(adjustMarginTop);
  var initialSetup = true;
  // Add listener for the mobile nav dropdown to move check and call button
  try {
    function moveCheckAndCall() {
      var nav = document.getElementById("header");
      var vw = $(window).width();

      function setupListeners() {
        nav.removeEventListener("show.bs.collapse", handleShow);
        nav.removeEventListener("hide.bs.collapse", handleHide);
        nav.addEventListener("show.bs.collapse", handleShow);
        nav.addEventListener("hide.bs.collapse", handleHide);
      }

      function handleShow() {
        if (vw <= 1199) {
          var addressChecker = nav.querySelector(
            ".navbar-button-wrap .address-checker-modal-mobile"
          );
          var addressCheckerClone = addressChecker.cloneNode(true); 

          var navExpanded = nav.querySelector(".navbar-collapse .navbar-nav");
          var accountLogin = nav.querySelector(".ns-account-login.mobile");
          var accountLogout = nav.querySelector(".ns-account-logout.mobile");

          addressChecker.style.display = "none";

          if (!nav.querySelector(".button-container")) {
            envConsoleLog("No button container, creating ");

            var buttonContainer = document.createElement("div");
            buttonContainer.classList.add("button-container");
            buttonContainer.style.display = "flex";
            buttonContainer.classList.add("flex-wrap");
            buttonContainer.style.width = "100%";
            buttonContainer.appendChild(addressCheckerClone);
            // buttonContainer.appendChild(accountLogin);
            // buttonContainer.appendChild(accountLogout);
            // add <span id="extole_zone_global_header" class="mt-4">
            if (!nav.querySelector("#extole_zone_mobile_menu")) {
              var extoleZone = document.createElement("span");
              extoleZone.id = "extole_zone_mobile_menu";

              extoleZone.classList.add("mt-4");
              extoleZone.classList.add("ms-auto");
              extoleZone.classList.add("me-auto");
              extoleZone.classList.add("d-block");
              // if button does not exist, append
              buttonContainer.appendChild(extoleZone);
            }
            navExpanded.appendChild(buttonContainer);
          } else {
            envConsoleLog("Button container exists, showing ");
            var buttonContainers = nav.querySelectorAll(".button-container");
            buttonContainers.forEach((container) => {
              container.style.display = "flex";

              envConsoleLog("Container: ", container);
            });
          }
        }
      }

      function handleHide() {
        if (vw <= 1199) {
          var addressChecker = nav.querySelector(
            ".navbar-button-wrap .address-checker-modal-mobile"
          );
          var navCollapsed = nav.querySelector(".navbar-button-wrap");
          var navExpanded = nav.querySelector(".navbar-collapse .navbar-nav");
          var buttonContainers = nav.querySelectorAll(".button-container");
          addressChecker.style.display = "flex";

          buttonContainers.forEach((container) => {
            
            if (
              container.contains(nav.querySelector(".ns-account-login.mobile"))
            ) {
              navExpanded.append(nav.querySelector(".ns-account-login.mobile"));
            }
            if (
              container.contains(nav.querySelector(".ns-account-logout.mobile"))
            ) {
              navExpanded.append(
                nav.querySelector(".ns-account-logout.mobile")
              );
            }
            container.style.display = "none";
          });
        }
      }

      if (initialSetup) {
        setupListeners();
        initialSetup = false;
      }
    }

    moveCheckAndCall();
    window.addEventListener("resize", moveCheckAndCall);
  } catch (e) {
    console.log(e);
  }

  const maxWidth = 768; // Max width for mobile devices
  if (document.querySelector("nav .customer-alert")) {
    const charLimit = document.querySelector("nav .customer-alert").dataset
      .charLimit;
  } else {
    const charLimit = 100;
  }
  const readMoreText = "Read More"; // Text for the Read More link
  // Function to truncate text
  function truncateText(selector) {
    const elements = document.querySelectorAll(selector);

    elements.forEach((element) => {
      const originalHTML = element.dataset.originalHtml || element.innerHTML;
      element.dataset.originalHtml = originalHTML; // Store original HTML

      const truncatedHTML =
        originalHTML.length > charLimit
          ? originalHTML.slice(0, charLimit) + "... "
          : originalHTML;

      if (window.innerWidth < maxWidth) {
        element.innerHTML = truncatedHTML;
        const readMoreLink = document.createElement("a");
        readMoreLink.href = "#";
        readMoreLink.innerText = readMoreText;
        readMoreLink.addEventListener("click", function (e) {
          e.preventDefault();
          if (element.innerHTML.includes("...")) {
            element.innerHTML = originalHTML;
          } else {
            element.innerHTML = truncatedHTML;
            element.querySelector("p").appendChild(readMoreLink);
          }
        });
        element.querySelector("p").appendChild(readMoreLink);
      } else {
        element.innerHTML = originalHTML;
      }
    });
  }

  truncateText("nav .customer-alert");
  window.addEventListener("resize", function () {
    truncateText("nav .customer-alert");
  });
});

